// extracted by mini-css-extract-plugin
export var actionButton = "_ff-t";
export var buttonContainer = "_ff-0";
export var buttonContainer2 = "_ff-1";
export var buttonSection = "_ff-2";
export var details = "_ff-3";
export var dropdownItem = "_ff-5";
export var dropdownItemsContainer = "_ff-4";
export var fileInput = "_ff-r";
export var headerButton = "_ff-6";
export var icon = "_ff-7";
export var input = "_ff-8";
export var macroListItem = "_ff-9";
export var mainContent = "_ff-a";
export var microText = "_ff-b";
export var modal = "_ff-w";
export var optionsButton = "_ff-c";
export var paperclip = "_ff-s";
export var pillContent = "_ff-d";
export var preview = "_ff-e";
export var preview2 = "_ff-f";
export var quillEditor = "_ff-q";
export var selectedMacro = "_ff-g";
export var sidebar = "_ff-h";
export var sidebarHeader = "_ff-j";
export var sidebarList = "_ff-i";
export var sidebarListItem = "_ff-k";
export var sidebarSearch = "_ff-l";
export var snoozeDurationWrapper = "_ff-v";
export var statusPillContainer = "_ff-m";
export var tagsContainer = "_ff-n";
export var unselectedMacro = "_ff-o";
export var variable = "_ff-u";
export var wrapper = "_ff-p";